/**
 * Input: 12:30 (string)
 * Output: 12 (number)
 */
const getHoursFromHM = (hm: string): number => {
  const [hours] = hm.split(':')
  return +hours * 1
}

export default getHoursFromHM
